import { Component, Input, OnInit } from '@angular/core';
import { faCloudArrowDown } from '@fortawesome/pro-solid-svg-icons';
import { IFileDocument } from 'src/modules/shared/models/interfaces/files.interface';
import { FilesService } from 'src/modules/shared/services/files.service';

@Component({
  selector: 'hcr-file-reader-header',
  templateUrl: './file-reader-header.component.html',
  styleUrls: ['./file-reader-header.component.sass']
})
export class FileReaderHeaderComponent implements OnInit {

  @Input() selectedFile: IFileDocument;

  public icons = {
    fileDownload: faCloudArrowDown
  };

  constructor(private _fileService: FilesService) { }

  ngOnInit(): void {
  }

  public openFile() {
    this._fileService.viewFile(this.selectedFile.fileURI);
  }

}
